export const updateAdapterStatus = data => ({
  type: "UPDATE_ADAPTTER_DATA",
  adapter: data || {}
});

